import React, { useContext } from "react"
import { useNavigate } from "react-router-dom"
import { Link, Button, Toolbar, Paper, Grid, useTheme, useMediaQuery } from "@mui/material"
import LogoKlein from "../../../components/logo/LogoKlein.png"
// import UserMenu from "../../../components/UserMenu"
import { F_INDEX, F_START_ABOUT, F_START_LOGIN, F_START_PARTNER } from "../../../constants/routes"
import UserContext from "../../../context/UserContext"

const tabs = [
  {
    title: "Von Schülern - Für Schüler",
    route: F_START_ABOUT,
  },
  {
    title: "Partnerschulen",
    route: F_START_PARTNER,
  },
]

const Header = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const { userData } = useContext(UserContext)

  return (
    <>
      <Toolbar sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Grid container justifyContent="space-between">
          <Grid item xs={2}>
            <Link href="http://demo.bookay-buecher.de" target="_blank" rel="noopener noreferrer" sx={{ textDecoration: "none" }}>
              <Button
                sx={{
                  display: isMobile ? "none" : "inherit",
                  backgroundColor: "start.main",
                  color: "#000",
                  "&:hover": {
                    backgroundColor: "start.hover",
                  },
                }}
                variant="contained"
                size="medium">
                Demoversion
              </Button>
            </Link>
          </Grid>
          <Grid item xs={8}>
            <Paper
              onClick={() => navigate(F_INDEX)}
              elevation={0}
              sx={{
                height: "40px",
                cursor: "pointer",
                flex: 1,
                position: "relative",
                color: "#fff",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundImage: `url(${LogoKlein})`,
              }}>
              .
            </Paper>
          </Grid>
          <Grid item xs={2}>
            {/* <UserMenu mainPage /> */}
            <Button
              sx={{
                float: "right",
                display: isMobile ? "none" : "inherit",
                backgroundColor: "start.main",
                color: "#000",
                "&:hover": {
                  backgroundColor: "start.hover",
                },
              }}
              onClick={() => navigate(F_START_LOGIN)}
              variant="contained"
              size="medium">
              {userData?.token ? "Zur App" : "Login"}
            </Button>
          </Grid>
        </Grid>
      </Toolbar>
      <Toolbar component="nav" variant="dense" sx={{ justifyContent: "space-around", overflowX: "auto" }}>
        {tabs.map((tab) => (
          <Link
            color="inherit"
            noWrap
            key={tab.title}
            variant="body2"
            onClick={() => navigate(tab.route)}
            sx={{ cursor: "pointer", p: 1, flexShrink: 0 }}>
            {tab.title}
          </Link>
        ))}
      </Toolbar>
    </>
  )
}

export default Header
